import { COLORS } from 'constants/index';
import typography from '../typography';

const MuiInputBase = {
  root: {
    ...typography.subtitle1,
    width: '100%',
    padding: '9px 16px 5px 16px',
    margin: '0',
    backgroundColor: COLORS.WHITE,
    border: `1px solid ${COLORS.BLACK_12}`,
    borderRadius: '4px',
    '&$disabled': {
      backgroundColor: COLORS.WHITE,
    },
  },
  input: {
    '&::placeholder': {
      ...typography.body2,
      color: COLORS.BLACK_3,
    },
    padding: 0,
    color: COLORS.BLACK_DARK,
  },
};

export default MuiInputBase;
